<mat-card class="bg-white mat-elevation-z3">
    <mat-card-header>
        <mat-card-title>
            <mat-icon class="mx-1" color="primary">task</mat-icon>
            {{ isArchive === '1' ? 'Archiwum zadań' : 'Zadania' }}
        </mat-card-title>
        <mat-card-subtitle>
            {{ isArchive === '1' ? 'Sprawdź archiwalne zadania' : 'Dodaj, sprawdź lub edytuj zadanie.' }}
        </mat-card-subtitle>
        <div class="mx-3" *ngIf="authService.user.type !== 'user' && isArchive !== '1'">
            <button mat-fab color="warn" matTooltip="Dodaj zadanie" (click)="addTask()"
                    matTooltipPosition="right" aria-label="Dodaj zadanie">
                <mat-icon>add</mat-icon>
            </button>
        </div>
    </mat-card-header>
    <mat-card-content>
        <div class="pt-4 pb-3">
            <div class="text-center text-md-start pb-2">
                <mat-form-field appearance="outline" style="width: 75%">
                    <mat-label>Zadanie...</mat-label>
                    <input type="text" matInput placeholder="Zadanie ..."
                           (keyup)="setSearchFilter()" [(ngModel)]="searchFilter">
                    <mat-icon matSuffix color="primary">search</mat-icon>
                </mat-form-field>
            </div>
            <mat-accordion>
                <mat-expansion-panel class="bg-white" (opened)="cleanFilter()" (closed)="cleanFilter()">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <i class="fa-solid fa-filter text-primary-color mx-2"></i> Filtry
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="pt-2">
                        <mat-slide-toggle [(ngModel)]="isDeadline">{{ isDeadline ? 'Termin' : 'Zadania' }}
                        </mat-slide-toggle>
                    </div>
                    <ng-container *ngIf="!isDeadline else deadlineTask">
                        <div class="pt-4 pb-md-1">
                            <mat-form-field appearance="outline" color="primary">
                                <mat-label>Zadania od:</mat-label>
                                <input matInput [matDatepicker]="startPicker" [formControl]="date">
                                <mat-hint>DD/MM/YYYY</mat-hint>
                                <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                                <mat-datepicker #startPicker (closed)="setSearchFromDate()"></mat-datepicker>
                            </mat-form-field>
                            <mat-form-field class="py-2 mx-1 mx-xl-3" appearance="outline" color="primary">
                                <mat-label>Zadania do:</mat-label>
                                <input matInput [matDatepicker]="endPicker" [formControl]="date">
                                <mat-hint>DD/MM/YYYY</mat-hint>
                                <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                                <mat-datepicker #endPicker (closed)="setSearchToDate()"></mat-datepicker>
                            </mat-form-field>
                            <button mat-stroked-button color="primary" (click)="searchByDate()"
                                    [disabled]="dateFrom === '' || dateTo === ''">
                                <mat-icon fontIcon="search"></mat-icon>
                                szukaj
                            </button>
                        </div>
                    </ng-container>
                    <ng-template #deadlineTask>
                        <div class="pt-4 pb-md-1">
                            <mat-form-field appearance="outline" color="primary">
                                <mat-label>Termin od:</mat-label>
                                <input matInput [matDatepicker]="startDeadlinePicker" [formControl]="deadline">
                                <mat-hint>DD/MM/YYYY</mat-hint>
                                <mat-datepicker-toggle matSuffix [for]="startDeadlinePicker"></mat-datepicker-toggle>
                                <mat-datepicker #startDeadlinePicker
                                                (closed)="setSearchFromDeadlineDate()"></mat-datepicker>
                            </mat-form-field>
                            <mat-form-field class="py-2 mx-1 mx-xl-3" appearance="outline" color="primary">
                                <mat-label>Termin do:</mat-label>
                                <input matInput [matDatepicker]="endDeadlinePicker" [formControl]="deadline">
                                <mat-hint>DD/MM/YYYY</mat-hint>
                                <mat-datepicker-toggle matSuffix [for]="endDeadlinePicker"></mat-datepicker-toggle>
                                <mat-datepicker #endDeadlinePicker
                                                (closed)="setSearchToDeadlineDate()"></mat-datepicker>
                            </mat-form-field>
                            <button mat-stroked-button color="primary" (click)="searchByDate()"
                                    [disabled]="deadlineFrom === '' || deadlineTo === ''">
                                <mat-icon fontIcon="search"></mat-icon>
                                szukaj
                            </button>
                        </div>
                    </ng-template>
                    <div class="pt-2 pt-md-1">
                        <mat-form-field class="pt-2" appearance="outline" color="primary">
                            <mat-label>Priorytet</mat-label>
                            <mat-select (selectionChange)="setPriorityFilter($event)"
                                        [(ngModel)]="priorityFilter">
                                <mat-option [value]="''">wszystkie</mat-option>
                                <mat-option value="normalny">normalny</mat-option>
                                <mat-option value="wysoki">wysoki</mat-option>
                                <mat-option value="niski">niski</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field *ngIf="isArchive === 'false'" class="pt-2 mx-md-3" appearance="outline"
                                        color="primary">
                            <mat-label>Status</mat-label>
                            <mat-select (selectionChange)="setStatusFilter($event)"
                                        [(ngModel)]="statusFilter">
                                <mat-option [value]="''">wszystkie</mat-option>
                                <mat-option value="utworzone">utworzone</mat-option>
                                <mat-option value="realizacja">realizacja</mat-option>
                                <mat-option value="wstrzymane">wstrzymane</mat-option>
                                <mat-option value="zrobione">zrobione</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <button [ngClass]="{'mx-xl-3': isArchive}" mat-stroked-button color="primary"
                                (click)="cleanFilter()">
                            <mat-icon fontIcon="cleaning_services"></mat-icon>
                            wyczyść
                        </button>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
        <div class="table-container pt-2 pb-4">
            <table mat-table [dataSource]="tasks$" matSort (matSortChange)="sortData($event)"
                   matSortActive="created_at" matSortDisableClear matSortDirection="asc">

                <!-- created_at column -->
                <ng-container matColumnDef="created_at">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="created_at">Utworzono</th>
                    <td mat-cell *matCellDef="let task">{{ task.created_at | date: 'dd/MM/yyyy' }}</td>
                </ng-container>

                <!-- deadline column -->
                <ng-container matColumnDef="deadline">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="deadline">Termin</th>
                    <td mat-cell *matCellDef="let task">{{ task.deadline | date: 'dd/MM/yyyy' }}</td>
                </ng-container>

                <!-- priority column -->
                <ng-container matColumnDef="priority">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="priority">Priorytet</th>
                    <td mat-cell *matCellDef="let task">
                        <app-task-priority-color [taskPriority]="task.priority"></app-task-priority-color>
                    </td>
                </ng-container>

                <!-- name column -->
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="name">Nazwa</th>
                    <td mat-cell *matCellDef="let task">{{ task.name }}</td>
                </ng-container>

                <!-- status column -->
                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="status">Status</th>
                    <td mat-cell *matCellDef="let task">
                        <app-task-status-color [taskStatus]="task.status"></app-task-status-color>
                    </td>
                </ng-container>

                <!-- actions column -->
                <ng-container matColumnDef="actions">
                    <th class="table-cell-width" mat-header-cell *matHeaderCellDef>akcje</th>
                    <td mat-cell *matCellDef="let task">
                        <div class="d-flex">
                            <button mat-mini-fab color="indigo" matTooltip="Pokaż"
                                    (click)="showTask(task.id)"
                                    matTooltipPosition="left" aria-label="Pokaż">
                                <mat-icon>remove_red_eye</mat-icon>
                            </button>
                            <button *ngIf="isArchive === 'false'" color="success" class="mx-2" mat-mini-fab
                                    matTooltip="Status"
                                    (click)="changeTaskStatus(task.id, task.priority, task.status)"
                                    matTooltipPosition="above" aria-label="Status">
                                <mat-icon>change_circle</mat-icon>
                            </button>
                            <button *ngIf="authService.user.type === 'admin' && isArchive === 'false'"
                                    mat-mini-fab color="warn"
                                    matTooltip="Zakończ"
                                    (click)="completeTask(task.id)"
                                    matTooltipPosition="right" aria-label="Zakończ">
                                <mat-icon>check_box</mat-icon>
                            </button>
                        </div>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>
        <mat-paginator class="bg-white" [length]="totalRows" [pageIndex]="currentPage" [pageSize]="pageSize"
                       [pageSizeOptions]="pageSizeOptions" (page)="pageChanged($event)">
        </mat-paginator>
        <ng-container *ngIf="!tasks$.data.length">
            <div class="text-center py-5">
                <p>Brak zadań.</p>
            </div>
        </ng-container>
        <div class="mt-3" *ngIf="isLoading">
            <mat-progress-bar mode="indeterminate" *ngIf="isLoading" color="primary"></mat-progress-bar>
        </div>
    </mat-card-content>
</mat-card>
